export const locale = {
  lang: 'en',
  data: {
    DEVICE_DETAILS: {
      TITLE: 'Device Details',
    },
  },
};
